import React, { useState, useEffect } from "react";
import { Modal, Form, Input, Button, message } from "antd";
import { createEmployee } from "../../services/employeeService";

// Create Employee Modal Component
export const CreateEmployeeModal = ({ visible, onCancel, onSuccess }) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  // Reset form when modal is closed
  useEffect(() => {
    if (!visible) {
      form.resetFields();
    }
  }, [visible, form]);


  const handleSubmit = async () => {
    try {
      const values = await form.validateFields();
      setLoading(true);
      const currentUserId = localStorage.getItem("userId");
      const employeeData = {
        ...values,
        createdByUserId: currentUserId
      };
      await createEmployee(employeeData);
      form.resetFields();
      message.success("Çalışan başarıyla oluşturuldu");
      onSuccess();
    } catch (error) {
      if (error.errorFields) {
        // Form validation error
      } else {
        message.error("Çalışan oluşturma başarısız");
        console.error("Error creating employee:", error);
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      title="Yeni Çalışan Oluştur"
      open={visible}
      onCancel={onCancel}
      footer={[
        <Button key="cancel" onClick={onCancel}>
          İptal
        </Button>,
        <Button
          key="submit"
          type="primary"
          loading={loading}
          onClick={handleSubmit}
        >
          Oluştur
        </Button>,
      ]}
    >
      <Form
        form={form}
        layout="vertical"
        initialValues={{
          name: "",
          surname: "",
          phoneNumber: "",
          password: "",
          username: "",
        }}
      >
        <Form.Item
          name="username"
          label="Kullanıcı Adı"
          rules={[
            { required: true, message: "Kullanıcı adı zorunludur" },
            {
              validator: (_, value) => {
                if (!value) return Promise.resolve(); // 'required' rule already handles empty
                if (value.includes(" ")) {
                  return Promise.reject("Kullanıcı adı boşluk içeremez");
                }
                return Promise.resolve();
              },
            },
            { max: 50, message: "Kullanıcı adı 50 karakteri geçemez" },
          ]}
          validateTrigger={["onChange", "onBlur"]}
        >
          <Input placeholder="Kullanıcı adı giriniz (boşluk içeremez)" />
        </Form.Item>


        <Form.Item
          name="name"
          label="Ad"
          rules={[
            { required: true, message: "Ad zorunludur" },
            { max: 100, message: "Ad 100 karakteri geçemez" },
          ]}
        >
          <Input />
        </Form.Item>

        <Form.Item
          name="surname"
          label="Soyad"
          rules={[
            { required: true, message: "Soyad zorunludur" },
            { max: 100, message: "Soyad 100 karakteri geçemez" },
          ]}
        >
          <Input />
        </Form.Item>

        <Form.Item
          name="phoneNumber"
          label="Telefon Numarası"
          rules={[
            { pattern: /^\+?[0-9\-\s]+$/, message: "Telefon numarası formatı geçersiz" },
            { max: 20, message: "Telefon numarası 20 karakteri geçemez" },
          ]}
        >
          <Input />
        </Form.Item>

        <Form.Item
          name="password"
          label="Şifre"
          rules={[{ required: true, message: "Şifre zorunludur" }]}
        >
          <Input.Password />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default CreateEmployeeModal;